<template>
    <validation-provider v-slot="v" :name="name" :rules="rules" slim mode="eager">
        <div class="form-group mb-0"
             :class="{
                 'has-feedback has-error': v.errors.length,
                 'row': inline && isLabelSlot,
                 'd-flex': inline && isLabelSlot,
             }">
            <label v-if="isLabelSlot && !mdForm" :for="id" :class="labelClass" class="mb-0 mt-2">
                <slot name="label"/>
            </label>
            <div :class="{'col-md-7': labelClass.length, 'input-group': isAppendSlot || isPrependSlot, 'md-form': mdForm }">
                <div v-if="isPrependSlot" class="input-group-prepend">
                    <slot name="input-prepend"/>
                </div>
                <input :id="id"
                       :name="name"
                       :placeholder="placeholder"
                       v-model="val"
                       :type="inputType"
                       :step="step"
                       :disabled="disabled"
                       :class="{'is-invalid': v.errors.length, 'form-control-sm': small, 'bg-discount': discountPrice, 'custom-green-input-bg': !noCustomBg}"
                       class="form-control"
                       @focus="onFocus"
                       @blur="onBlur">
                <label v-if="isLabelSlot && mdForm" :for="id" :class="labelClass">
                    <slot name="label"/>
                </label>
                <div v-if="isAppendSlot" class="input-group-append">
                    <slot name="input-append"/>
                </div>
                <div class="invalid-feedback">
                    {{ v.errors[0] }}
                </div>
            </div>
        </div>
    </validation-provider>
</template>

<script>
export default {
    name: 'AppInput',
    props: {
        id: [String, Number],
        value: [String, Number],
        type: String,
        step: String,
        placeholder: String,
        inline: Boolean,
        mdForm: Boolean,
        disabled: Boolean,
        noCustomBg: Boolean,
        discountPrice: Boolean,
        name: String,
        rules: String,
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        val: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        inputType() {
            if (this.type) {
                return this.type;
            }
            return 'text';
        },
        labelClass() {
            if (this.inline) {
                return 'col-md-3 col-form-label text-md-right';
            }

            return '';
        },
        isLabelSlot() {
            return !!this.$slots.label;
        },
        isAppendSlot() {
            return !!this.$slots['input-append'];
        },
        isPrependSlot() {
            return !!this.$slots['input-prepend'];
        },
    },
    methods: {
        onBlur(e) {
            this.$emit('blur', e);
        },
        onFocus(e) {
            this.$emit('focus', e);
        }
    }
};
</script>
<style>
.bg-discount {
    background: #ffebeb!important;
}
</style>
